import { isJD } from '@/utils/channel'
import { getPhoneOS } from '@/utils/helper'
import { JD_OPENAPP_LINK_HOME, JD_WEBVIEW_CODE } from '@/config/jsBridge'
import { reportSGM } from '@/utils/sgm'

import { EPhoneOS } from '@/models/view/common'
import { EPageBouncesStatus, type IJDBridge } from '@/models/libs/JDBridge'
import { SGM_TYPE } from '@/utils/sgm'

function checkJmfe(methodName: keyof IJDBridge, errorKey: string) {
  if (!jmfe || typeof jmfe[methodName] !== 'function') {
    reportSGM({
      code: errorKey,
      desc: 'jmfe init error',
    })
    return false
  }
  return true
}

/**
 * @description 调用关闭Webview方法
 */
export function closeWebviewInJD(next: Function) {
  if (!isJD) return next()
  if (!checkJmfe('closeWebview', 'CLOSE_WEBVIEW_IN_JD_ERROR')) return
  registerWebview()
  jmfe!.closeWebview()
}

/**
 * @description 注册Webview，注册后可以调用Webview相关API
 */
export function registerWebview() {
  if (!isJD) return
  if (!checkJmfe('registerCode', 'REGISTER_WEBVIEW_IN_JD_ERROR')) return
  jmfe!.registerCode(JD_WEBVIEW_CODE)
}

/**
 * @description 调用跳转首页方法
 */
export function jumpToJDIndexWebview(next: Function) {
  if (!isJD) return next()
  reportSGM({
    type: SGM_TYPE.Info,
    code: 'JUMP_INTO_APP_INDEX',
    desc: '【京东App】调用跳转首页桥方法',
  })
  window.location.href = JD_OPENAPP_LINK_HOME
}

/**
 * @description 返回上一页，若当前是第一页则关闭当前webview
 */
export function goBackInJD(next: Function) {
  if (!isJD) return next()
  if (!checkJmfe('goBackRouter', 'GO_BACK_IN_JD_ERROR')) return
  registerWebview()
  jmfe!.goBackRouter()
}

export function disablePageBouncesInJD() {
  const platform = getPhoneOS()
  if (!isJD || platform !== EPhoneOS.IOS) return
  if (!checkJmfe('togglePageBounces', 'JSBridge_togglePageBouncesInJD')) return
  registerWebview()
  jmfe!.togglePageBounces(EPageBouncesStatus.Disable)
}

export function getAppVersionInJD(next: Function) {
  if (!isJD) return next()
  if (!checkJmfe('getAppVersion', 'JSBridge_getAppVersionInJD')) return
  return jmfe!.getAppVersion('jd')
}
